import { queryOptions, useQuery } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/client'

export const billingKeys = {
  all: ['billing'] as const,
  paymentsConfig: () => ['billing', 'payments-config'] as const,
  overview: (organizationId: string) =>
    ['billing', 'overview', organizationId] as const,
  topUps: (organizationId: string) =>
    ['billing', 'top-ups', organizationId] as const,
}

/** Provider and test mode do not change while the page is open. */
export function paymentsConfigQueryOptions() {
  return queryOptions({
    queryKey: billingKeys.paymentsConfig(),
    queryFn: () => apiClient.payments.config(),
    staleTime: Infinity,
  })
}

export function usePaymentsConfigQuery() {
  return useQuery(paymentsConfigQueryOptions())
}

export function useBillingTopUpsQuery(organizationId: string | null) {
  return useQuery({
    queryKey: billingKeys.topUps(organizationId ?? ''),
    queryFn: () => apiClient.billing.topUps(organizationId ?? ''),
    enabled: Boolean(organizationId),
  })
}
